import React from 'react';
import { BLOCKER_LABELS } from '../../platform/store/useOperationalStore';
import { fmtAgo } from './roHelpers';
import DetailSection from './DetailSection';

export default function BlockerPanel({
  currentBlocker, canEdit, isClosed, now,
  blockerFormOpen, setBlockerFormOpen,
  blockerType, setBlockerType, blockerDesc, setBlockerDesc, blockerOwner, setBlockerOwner,
  handleSetBlocker, handleClearBlocker,
}) {
  return (
    <DetailSection title={currentBlocker ? '⛔ Blocked' : 'Blocker'} defaultOpen>
      {currentBlocker ? (
        <div className="ro-blocker-active">
          <div className="ro-blocker-type">{BLOCKER_LABELS[currentBlocker.type] || currentBlocker.type}</div>
          {currentBlocker.description && <div className="ro-blocker-desc">{currentBlocker.description}</div>}
          <div className="ro-blocker-meta">
            Set by {currentBlocker.setBy || '—'} · {fmtAgo(currentBlocker.setAt, now)} ago
            {currentBlocker.owner && ` · Owner: ${currentBlocker.owner}`}
          </div>
          {canEdit && !isClosed && (
            <button className="ro-btn ro-btn--resolve" onClick={handleClearBlocker}>✓ Resolve Blocker</button>
          )}
        </div>
      ) : (
        <>
          <div className="ro-blocker-none">No active blocker</div>
          {canEdit && !isClosed && (
            blockerFormOpen ? (
              <div className="ro-blocker-form">
                <select className="ro-form-select" value={blockerType} onChange={e => setBlockerType(e.target.value)}>
                  {Object.entries(BLOCKER_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                </select>
                <input className="ro-form-input" placeholder="Description (optional)"
                  value={blockerDesc} onChange={e => setBlockerDesc(e.target.value)} />
                <input className="ro-form-input" placeholder="Owner (optional)"
                  value={blockerOwner} onChange={e => setBlockerOwner(e.target.value)} />
                <div className="ro-form-row">
                  <button className="ro-btn ro-btn--primary" onClick={handleSetBlocker}>Set Blocker</button>
                  <button className="ro-btn ro-btn--ghost" onClick={() => setBlockerFormOpen(false)}>Cancel</button>
                </div>
              </div>
            ) : (
              <button className="ro-btn ro-btn--ghost ro-btn--sm" onClick={() => setBlockerFormOpen(true)}>
                Set Blocker
              </button>
            )
          )}
        </>
      )}
    </DetailSection>
  );
}
